import { createSlice } from "@reduxjs/toolkit";

export const checkSSRState = {
  isSSR: false,
};

const CheckSSRSlice = createSlice({
  name: "checkSSR",
  initialState: checkSSRState,
  reducers: {
    setSSR(state) {
      state.isSSR = true;
    },
  },
});

export const CheckSSRActions = {
  ...CheckSSRSlice.actions,
};

export default CheckSSRSlice.reducer;
